<template>
    <v-container>
        <v-card>
            <v-card-text>
                <v-expansion-panels multiple v-model="panel" focusable>
                    <v-expansion-panel key="customer"  class="mb-1">
                        <v-expansion-panel-header >
                            ข้อมูลลูกค้า
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <JobCustomer key="cnt" ref="jobCustomer" :branchCode="branchCode" :isEditMode="true"></JobCustomer>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                    <v-spacer ></v-spacer>
                    <v-expansion-panel key="car"  class="mb-1">
                        <v-expansion-panel-header>
                            ข้อมูลรถยนต์
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <JobCar key="cnt" ref="jobCar" :branchCode="branchCode" :isEditMode="true"></JobCar>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import JobCustomer from '../JobCustomer'
import JobCar from '../JobCar'

export default {
    name: 'Tab1',
    components: {
        JobCustomer,
        JobCar
    },
    props: ["job", "canEdit", "branchCode"],
    data: () => ({
        panel: [],
        cnt: 0
    }),
    methods: {
        setTab1Data(jobCar, jobCustomer) {
            this.$nextTick(() => {
                this.$refs.jobCar.setJobCar(jobCar);
                this.$refs.jobCustomer.setJobCustomer(jobCustomer);
                //this.panel = [];
                this.cnt++;
            });
        }
    },
    mounted() {
        this.panel = [0, 1];
    }
}
</script>